import { BaseModel } from "../base-model";

export interface IPropertyPublicUtilityModel {
    Id:number;
    PropertyId:number;
    WaterCustomerId:string;
    NewWaterSupplier: string;
    PreviousWaterSupplier: string;
    GasEAN:  string;
    WaterMeterNumber: string;
    WaterMeterValue:number;
    GasMeterNumber: string;
    GasMeterValue: number;
    NewGasSupplier:string;
    PreviousGasSupplier:string;
    ElectricityEAN: string;
    NewElectricitySupplier:string;
    PreviousElectricitySupplier:string;
    ElectricitySimpleMeterNumber:string;
    ElectricitySimpleMeterValue: number;
    ElectricityDoubleMeterNumber: string;
    ElectricityDoubleMeterDayValue: number;
    ElectricityDoubleMeterNightValue: number;
    ElectricityNightOnlyMeterNumber:string;
    ElectricityNightOnlyMeterValue: number;
    ItemState:number;
}
export class PropertyPublicUtilityModel extends BaseModel<IPropertyPublicUtilityModel>
  implements IPropertyPublicUtilityModel {
    Id:number;
    PropertyId:number;
    WaterCustomerId:string;
    NewWaterSupplier: string;
    PreviousWaterSupplier: string;
    GasEAN:  string;
    WaterMeterNumber: string;
    WaterMeterValue:number;
    GasMeterNumber: string;
    GasMeterValue: number;
    NewGasSupplier:string;
    PreviousGasSupplier:string;
    ElectricityEAN: string;
    NewElectricitySupplier:string;
    PreviousElectricitySupplier:string;
    ElectricitySimpleMeterNumber:string;
    ElectricitySimpleMeterValue: number;
    ElectricityDoubleMeterNumber: string;
    ElectricityDoubleMeterDayValue: number;
    ElectricityDoubleMeterNightValue: number;
    ElectricityNightOnlyMeterNumber:string;
    ElectricityNightOnlyMeterValue: number;
    ItemState:number;
  /**
   *
   */
  constructor(option?: IPropertyPublicUtilityModel) {
    super(option);
    
    this.Id = 0;
    this.PropertyId = 0;
    this.WaterCustomerId = null;
    this.NewWaterSupplier = null;
    this.PreviousWaterSupplier = null;
    this.GasEAN = null;
    this.WaterMeterNumber = null;
    this.WaterMeterValue = null;
    this.GasMeterNumber =  null;
    this.GasMeterValue = null;
    this.NewGasSupplier = null;
    this.PreviousGasSupplier = null;
    this.ElectricityEAN = null;
    this.NewElectricitySupplier = null;
    this.PreviousElectricitySupplier = null;
    this.ElectricitySimpleMeterNumber = null;
    this.ElectricitySimpleMeterValue = null;
    this.ElectricityDoubleMeterNumber = null;
    this.ElectricityDoubleMeterDayValue = null;
    this.ElectricityDoubleMeterNightValue = null;
    this.ElectricityNightOnlyMeterNumber = null;
    this.ElectricityNightOnlyMeterValue = null;
    this.ItemState = 0;
  }
}
